import React, { useState } from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { PlayCircleFilled } from '@mui/icons-material';
import { ExplainerVideoModal } from 'apps/sigma2-ui/src/components/ExplainerVideoModal';

export const ExplainerVideoLink = () => {
  const language = useLanguage();
  const [showBiasesVideo, setShowBiasesVideo] = useState(false);

  const learnAboutBiasesVideoLink =
    'https://www.youtube.com/embed/b-eZQxZXIqs?autoplay=1';

  return (
    <>
      <button
        className="flex flex-row text-xs font-semibold items-center"
        onClick={(e) => {
          e.preventDefault();
          setShowBiasesVideo(true);
        }}
      >
        <span>{language.focusAreaDisparityCalibrationTypeLink()}</span>
        <PlayCircleFilled className="ml-1.5 w-4" />
      </button>
      <ExplainerVideoModal
        videoUrl={learnAboutBiasesVideoLink}
        open={showBiasesVideo}
        title={language.learnAboutBiasesModalTitle()}
        onClose={() => setShowBiasesVideo(false)}
      />
    </>
  );
};
